import { render } from "./hotel.vue?vue&type=template&id=02c3238a&scoped=true"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=02c3238a&rel=stylesheet%2Fscss&lang=scss"
import "./hotel.vue?vue&type=style&index=1&id=02c3238a&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c3238a"]])

export default __exports__